import ProductEdit from '../components/Products/ProductEdit'; // Assuming you have this component
import { t } from '../i18n';

export default function ProductEditPage({ handleEditProduct }) {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">{t('Уреди производ')}</h2>
      <ProductEdit onAdd={handleEditProduct} />
    </>
  );
}
